module.exports = __webpack_public_path__ + "static/media/map-2.6fe814cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-2.png
// module id = 584
// module chunks = 23